import { Outlet, useLocation } from 'react-router-dom';

import { TopNav } from './TopNav';
import { Footer } from './Footer';

// Routes that render their own full-screen chrome (no site nav/footer).
// The simulator renders its own TopNav (a full-height console), so it opts out of the
// site chrome the layout would otherwise add.
const FULL_SCREEN_PATHS = new Set(['/', '/dashboard', '/onboarding', '/signin', '/simulator']);

export function AppLayout() {
  const { pathname } = useLocation();
  const full = [...FULL_SCREEN_PATHS].some((p) => pathname === p || pathname.startsWith(p + '/'));

  return (
    <div
      style={{
        minHeight: '100vh',
        background: full ? '#fff' : 'var(--neutral-200)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {!full && <TopNav />}
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>
      {!full && <Footer />}
    </div>
  );
}
